import { TextAutocompleteConfig } from '../../autocomplete/text-autocomplete.types';
import {FieldConfig} from '../../dynamic-field/field.config';

export interface TextAreaFieldConfig extends FieldConfig<string> {
    maxLength?: number;
    minRows?: number;
    maxRows?: number;
    autosize?: boolean;
    cols?: number;
    rows?: number;
    showClearButtonIfReadonly?: boolean;
    autocompleteConfig?: TextAutocompleteConfig;
}
